import type { AppState } from '@auth0/auth0-react';
import { Auth0Provider } from '@auth0/auth0-react';
import type { UserManagerSettings } from 'oidc-client';
import type { ReactNode } from 'react';
import { createContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { config } from '../config';
import type { IDSUser } from '../models/user';

export interface IAuthContext {
  signinRedirectCallback: () => Promise<any>;
  getToken: () => Promise<string>;
  logout: () => {};
  isAuthenticated: () => {};
  signinRedirect: (url: string) => {};
  signinSilentCallback: () => {};
  getUser: () => Promise<IDSUser>;
}

export interface AuthProviderProps {
  children: ReactNode;
  configuration: UserManagerSettings;
}

export const AuthContext = createContext<IAuthContext | null>(null);

export const AuthConsumer = AuthContext.Consumer;

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const domain = new URL(config.authUrl).hostname;

  // console.log('AuthProvider', { config });

  const onRedirectCallback = (appState?: AppState) => {
    // console.log('appState', appState)
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  return (
    <Auth0Provider
      onRedirectCallback={onRedirectCallback}
      domain={domain}
      clientId={config.authClientID}
      redirectUri={`${window.location.origin}/auth`}
      scope="openid profile fuel.api bitcentral.fuel.channelapi"
      useRefreshTokens
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
